import type { WidgetConfig } from '../types';
import { h } from '../utils/dom';
import { renderAvatars } from './avatar';
import { getCloseIcon, getMinimizeIcon } from './mark';

export class Header {
  el: HTMLDivElement;

  constructor(
    config: WidgetConfig,
    onMinimize: () => void,
    onClose: () => void,
  ) {
    const cfg = config.config;

    this.el = h('div', { class: 'att-header', role: 'banner' }) as HTMLDivElement;

    // Avatars
    if (cfg.teamShowAvatars && config.team.length > 0) {
      const avatarsWrap = h('div', { class: 'att-header-avatars' });
      renderAvatars(config.team, avatarsWrap);
      this.el.appendChild(avatarsWrap);
    }

    // Info
    const info = h('div', { class: 'att-header-info' });
    const name = h('div', { class: 'att-header-name' }, cfg.brandName);
    info.appendChild(name);

    if (cfg.msgHeaderSubtitle) {
      const sub = h('div', { class: 'att-header-subtitle' });
      if (config.status.online) {
        const dot = h('span', { class: 'att-header-online' });
        sub.appendChild(dot);
      }
      sub.appendChild(document.createTextNode(cfg.msgHeaderSubtitle));
      info.appendChild(sub);
    }
    this.el.appendChild(info);

    // Action buttons
    const actions = h('div', { class: 'att-header-actions' });

    const minimizeBtn = h('button', {
      class: 'att-header-btn',
      type: 'button',
      'aria-label': 'Minimizar',
    }) as HTMLButtonElement;
    minimizeBtn.innerHTML = getMinimizeIcon('white', 18);
    minimizeBtn.addEventListener('click', onMinimize);
    actions.appendChild(minimizeBtn);

    const closeBtn = h('button', {
      class: 'att-header-btn',
      type: 'button',
      'aria-label': 'Fechar',
    }) as HTMLButtonElement;
    closeBtn.innerHTML = getCloseIcon('white', 18);
    closeBtn.addEventListener('click', onClose);
    actions.appendChild(closeBtn);

    this.el.appendChild(actions);
  }
}
